<template>
    <div class="codeVerifyBox">
        <div class="codeVerifyBoxLeft">
            <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                <FormItem prop="code">
                    <p>证书编号</p>
                    <Input type="text" v-model="formInline.code" placeholder="请输入证书编号"></Input>
                </FormItem>
                <FormItem prop="yanzhengCode">
                    <p style="margin-top:24px">验证码</p>
                    <div class="yanzhengmaBox">
                        <Input type="text" v-model="formInline.yanzhengCode" placeholder="请输入验证码"></Input>
                        <img :src="captchaImg"
                        @click="getCaptchaImg"
                        alt="加载验证码失败"/>
                    </div>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="handleSubmit('formInline')">开始核验</Button>
                </FormItem>
            </Form>
        </div>
        <div class="codeVertifyBoxline"></div>
        <div class="codeVerifyBoxRight">
            <h2>核验结果</h2>
            <!-- 没进行核验的状态 -->
            <div class="noData" v-if='stateHy == 1'>
                <img src='./image/kongbai.png'/>
                <p>请在左侧上传文件或输入证书编号进行核验</p>
            </div>
            <!-- 核验通过的状态 -->
            <div class="verifySuccess" v-if='stateHy == 2'>
                <div class="one">
                    <img src='./image/verifySuccess.png'/>
                    <div class="txt">
                        <p class="txt_o">核验通过</p>
                        <p class="txt_t">找到与证书编号对应的存证证书</p>
                    </div>
                </div>
                <div class="two">
                    <div>
                        <p class="txt">证书授时时间：</p>
                        <p class="code">{{objectRes && objectRes.certTscTime}}</p>
                    </div>
                </div>
                <ul class="list">
                    <li>
                        <span>证书类型：</span>
                        <span v-if="objectRes && objectRes.certType ==0">版权存证</span>
                        <span v-if="objectRes && objectRes.certType ==1">网页取证</span>
                        <span v-if="objectRes && objectRes.certType =='a'">网页取证（渠道）</span>
                        <span v-if="objectRes && objectRes.certType =='b'">录屏取证（渠道）</span>
                        <span v-if="objectRes && objectRes.certType =='c'">APP取证（渠道）</span>
                        <span v-if="objectRes && objectRes.certType =='d'">过程取证（渠道）</span>
                    </li>
                    <li>
                        <span>证书状态：</span>
                        <span>已签发</span>
                    </li>
                    <li>
                        <span>证书编号：</span>
                        <span>{{objectRes && objectRes.certNumber}}</span>
                    </li>
                    <li>
                        <span>核验单位：</span>
                        <span>{{objectRes && objectRes.verifyUnit}}</span>
                    </li>
                </ul>
                <div class="three" @click="goVerDtl">
                    <span>查看核验详情</span>
                    <img src='./image/jiantou.png'/>
                </div>
            </div>
            <!-- 核验失败的状态 -->
            <div class="verifyErr" v-if='stateHy == 3'>
                <div class="one">
                    <img src='./image/verifyErr.png'/>
                    <div class="txt">
                        <p class="txt_o">核验未通过</p>
                        <p class="txt_t">无法查验到与该证书编号一致的信息，请核对输入信息</p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import {bqjUrl} from "@/config/config"
    import {getVerifyInfoByCertCode,_getCaptchaId} from '../../../api/evidence.js';
    // 验证码渲染图片接口
    export const drawCodeImage = "/bqjvip/captcha/draw/"
    export default {
        name:'codeVerification',
        data() {
            const validateCode = (rule, value, callback) => {
                if (value.length == 32) {
                    callback();
                }else {
                    callback(new Error("证书编号长度为32位"));
                }
            };
            return {
                formInline: {
                    code: '',
                    yanzhengCode: ''
                },
                ruleInline: {
                    code: [
                        {
                            required: true,
                            message: "请输入证书编号",
                            trigger: "blur"
                        },
                        {
                            validator: validateCode,
                            trigger: "blur"
                        }
                        // { required: true, message: '请输入证书编号/证书编号格式错误，请重新输入', trigger: 'blur' }
                    ],
                    yanzhengCode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                    ]
                },
                stateHy:1,
                captchaImg:"",
                captchaId:"",
                objectRes:null,
                bqjUrlTh: bqjUrl,
            }
        },
        created() {
        },
        mounted(){
            this.getCaptchaImg()
        },
        methods: {
            goVerDtl(){
                let routeUrl = this.$router.resolve({
                    path: "/index/creation_verification",
                    name: 'creationVerification',
                    params: {type: this.objectRes.certType, id: this.objectRes.orderSeqNo,isShowVer:"code",fileId:"1",fileName:"2"}//显示文件核验
                });
                window.open(routeUrl.href, '_blank');
            },
            getCaptchaImg(){
                _getCaptchaId().then(res=>{
                    if (res.success) {
                        this.captchaId = res.result;
                        this.captchaImg = this.bqjUrlTh + "/hatch/common/captcha/draw/" + this.captchaId;
                    }
                })
                
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        console.log(this.formInline.code)
                        // this.$parent.spinShowT();
                        // this.$emit("spinShowT")
                        this.$Spin.show();
                        let par={
                            captchaId:this.captchaId,
                            imageCode:this.formInline.yanzhengCode,
                            certCode:this.formInline.code
                        }
                        getVerifyInfoByCertCode(par).then(res=>{
                            if(res.code ==200){
                                this.objectRes = res.result;
                                this.stateHy = 2;
                            }else if(res.code ==10107 || res.code ==202){
                                    toast(res.message)
                                    this.stateHy = 1;
                            }else{
                                toast(res.message)
                                this.stateHy = 3;
                            }
                            this.$Spin.hide();
                            // this.$emit("spinShowF")
                        })
                    }
                })
            },
            initFunc(){
                this.formInline.yanzhengCode="";
                this.formInline.code="";
                this.stateHy =1;
                this.getCaptchaImg()
            }
        }
    }
</script>
<style lang="less" scoped>
.codeVerifyBox{
    display: flex;
    .codeVerifyBoxLeft{
        width: 385px;
        /deep/ .ivu-form-inline .ivu-form-item{
            display: block;
        }
        /deep/ .ivu-btn{
            width: 385px;
            height: 44px;
            background: #FFD800;
            border-radius: 4px;
            font-size: 16px;
            color: #333333;
            line-height:44px;
            margin-top: 29px;
            text-align: center;
            border: none;
            outline: none;
        }
         /deep/ .ivu-btn:focus{
            border: none;
            box-shadow:none ;
            outline: none;
        }
         /deep/ .ivu-btn:hover{
            border: none;
            outline: none;
            box-shadow:none ;
        }
        .yanzhengmaBox{
            position: relative;
            img{
                width: 100px;
                height: 32px;
                position: absolute;
                bottom: 7px;
                right: 0;
                cursor: pointer;
            }
            /deep/ .ivu-input{
                padding-right:120px;
                box-sizing: border-box;
            }
        }
        p{
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            margin-bottom: 8px;
        }
        /deep/ .ivu-input{
            display:block;
            width: 100%;
            height:46px;
            line-height:46px;
            padding:12px 0;
            font-size: 16px;
            border:none;
            background-color: #fff;
            background-image: none;
            border-bottom: 1px solid #EDEDED;
            outline: none;
            border-radius: 0;
        }
        /deep/ .ivu-input:focus {                                                                
            border:none;
            border-bottom: 1px solid #EDEDED;
            box-shadow:none ;
             outline: none;
        }
        /deep/ .ivu-input:hover {
            border:none;
            border-bottom: 1px solid #EDEDED;
             outline: none;
        }
    }
    .codeVertifyBoxline{
        width: 1px;
        height: 440px;
        margin: 0 141px 0 145px;
        background: #E5E5E5;
    }
    .codeVerifyBoxRight{
        .noData{
            img{
                width: 230px;
                height: 166px;
                display: block;
                margin: 102px 0 22px 197px;
            }
            p{
                font-size: 14px;
                color: #BDBDBD;
                line-height: 20px;
                margin-left:197px;
            }
        }
        h2{
            font-size: 17px;
            font-weight: 600;
            color: #333333;
            line-height: 24px;
        }
        .verifySuccess{
            margin-top: 36px;
            .one{
                display: flex;
                img{
                    width: 60px;
                    height: 60px;
                    display: block;
                    margin-right: 20px;
                }
                .txt{
                    flex: 1;
                    .txt_o{
                        font-size: 20px;
                        font-weight: 600;
                        color: #00B837;
                        line-height: 28px;
                        margin:3px 0 6px;
                    }
                    .txt_t{
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                        width: 490px;
                    }
                }
            }
            .two{
                width: 662px;
                height:86px;
                background: #FBFCFF;
                border-radius: 8px;
                padding-left: 20px;
                box-sizing: border-box;
                margin-top: 36px;
                margin-bottom:36px;
                .txt{
                    font-size: 14px;
                    color: #999999;
                    line-height: 20px;
                    padding: 20px 0 6px;
                    box-sizing: border-box;
                }
                .code{
                    font-size: 14px;
                    color: #333333;
                    line-height: 20px;
                }
            }
            .list{
                list-style: none;
                li{
                    display: flex;
                    span:nth-of-type(1){
                        width: 75px;
                        font-size: 12px;
                        color: #999999;
                        line-height: 17px;
                        display: inline-block;
                    }
                    span:nth-of-type(2){
                        flex:1;
                        font-size: 12px;
                        color: #333333;
                        line-height: 17px;
                    }
                }
            }
            .three{
                width: 156px;
                height: 36px;
                border-radius: 18px;
                border: 1px solid #BDBDBD;
                font-size: 14px;
                color: #999999;
                display: flex;
                align-items: center;
                justify-content: center;
                // vertical-align: middle;
                cursor: pointer;
                margin-top: 30px;
                &:hover{
                    background: #FFD800;
                    // color: #333333;
                    border-color:#FFD800;
                }
                img{
                    width: 14px;
                    height: 14px;
                    margin-left: 8px;
                }
            }
        }
        .verifyErr{
            margin-top: 36px;
            .one{
                display: flex;
                img{
                    width: 60px;
                    height: 60px;
                    display: block;
                    margin-right: 20px;
                }
                .txt{
                    flex: 1;
                    .txt_o{
                        font-size: 20px;
                        font-weight: 600;
                        color: #F55935;
                        line-height: 28px;
                        margin:3px 0 6px;
                    }
                    .txt_t{
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                        width: 490px;
                    }
                }
            }
        }
    }
}
</style>
